import { render, staticRenderFns } from "./MoleculeNotification.vue?vue&type=template&id=eff11f52&"
import script from "./MoleculeNotification.vue?vue&type=script&lang=ts&"
export * from "./MoleculeNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports